// extracted by mini-css-extract-plugin
module.exports = {"bg":"auth_bg__2fxY9","auth__footer":"auth_auth__footer__1rpbD"};